import { Place, CubeBuilder } from 'cube'

import { AnaliseBulasPresenter } from './analise-bulas/analise-bulas.presenter'
import { AnaliseReacoesPresenter } from './analise-reacoes/analise-reacoes.presenter'
import { Places } from './RouteConsts'

const prepare = CubeBuilder.lazyBuild({
    'bulas': {
        presenter: Place.creator(AnaliseBulasPresenter, Places, 'analiseBulas'),
    },

    'reacoes': {
        presenter: Place.creator(AnaliseReacoesPresenter, Places, 'analiseReacoes'),
    }
})

export function initialize() {
    prepare()
    return Places
}